module.exports = __webpack_public_path__ + "img/header-diamondJewelrySignature@2x.9606bc5.jpg";